// client/admin-client/src/components/notice/noticeApi.js
import { localizeServerMessage } from '../../i18n';
import { normalizeNotice, sortNoticeItems } from './noticeStorage';
import { getAdminAuthHeaders, handleAdminUnauthorized } from '../../auth/adminSession';

const API_BASE = String(
  process.env.REACT_APP_ADMIN_API_BASE_URL ||
  process.env.REACT_APP_API_BASE ||
  ''
).replace(/\/$/, '');

const NOTICE_BASE = `${API_BASE}/admin/notices`;

function getAuthHeaders() {
  return getAdminAuthHeaders();
}

async function request(url, options = {}) {
  const isFormData =
    typeof FormData !== 'undefined' && options.body instanceof FormData;

  const res = await fetch(url, {
    method: options.method || 'GET',
    credentials: 'include',
    headers: {
      ...getAuthHeaders(),
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      ...(options.headers || {}),
    },
    body: options.body,
  });

  handleAdminUnauthorized(res.status, url);

  const text = await res.text();
  let data = null;

  try {
    data = text ? JSON.parse(text) : null;
  } catch (_) {
    data = text;
  }

  if (!res.ok || (data && typeof data === 'object' && data.ok === false)) {
    const rawMessage =
      data?.message ||
      (typeof data === 'string' ? data : '') ||
      `HTTP ${res.status}`;
    throw new Error(localizeServerMessage(rawMessage, '공지 요청을 처리하지 못했습니다.'));
  }

  return data;
}

export async function fetchAdminNotices() {
  const data = await request(NOTICE_BASE);
  const items = Array.isArray(data?.items)
    ? data.items
    : Array.isArray(data)
      ? data
      : [];

  return sortNoticeItems(items.map(normalizeNotice));
}

export async function createNotice(payload) {
  const data = await request(NOTICE_BASE, {
    method: 'POST',
    body: JSON.stringify(payload || {}),
  });

  return normalizeNotice(data?.item || data);
}

export async function updateNotice(noticeId, payload) {
  const data = await request(`${NOTICE_BASE}/${encodeURIComponent(noticeId)}`, {
    method: 'PUT',
    body: JSON.stringify(payload || {}),
  });

  return normalizeNotice(data?.item || data);
}

export async function deleteNotice(noticeId) {
  return request(`${NOTICE_BASE}/${encodeURIComponent(noticeId)}`, {
    method: 'DELETE',
  });
}

// [ADD][ANCHOR:NOTICE_API:UPLOAD_NOTICE_IMAGE]
export async function uploadNoticeImage(file) {
  const formData = new FormData();
  formData.append('image', file);

  const data = await request(`${NOTICE_BASE}/upload-image`, {
    method: 'POST',
    body: formData,
  });

  return data?.item || null;
}